'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('servicerequest-ticket-edit', {
      url: '/servicerequest/ticket/edit/:id',
      template: '<service-request-ticket-edit></service-request-ticket-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/servicerequests/ticket-edit/servicerequest-ticket-edit.routes.js